/* fh-bogo-popup — BOGO buy box with a 3-step purchase sheet. 2026-09-13.
   CTA -> (1) how many -> (2) colors for every pillow -> (3) sleep masks
        -> /cart/add.js -> /checkout.
   Self-contained: no cart drawer, no bundle section, no shared globals, no
   MutationObserver. Going straight to checkout also means the drawer's
   teardown/normalizer logic is never involved.

   ⚠️ PRICING CONTRACT — do not "simplify" this.
   Free pillows are NOT $0 variants. We add the tier's FULL unit count of one
   real variant and Shopify's ACTIVE automatic BxGy discounts ("Buy 1 Get 1
   Free", "Buy 2 & Get 2 Free!!", "Buy 3 & Get 3 Free!!") zero the free units.
   Add fewer units than tier.n and the discount never fires -> the customer is
   overcharged. Verified live 2026-09-13 against /cart/add.js + /cart.js:
   n=2 -> 1 unit charged, n=4 -> 2, n=6 -> 3.

   ⚠️ MASK BOGO. Masks are "Buy 1 Get 1 FREE" ONLY through this popup, via the
   code discount MASKBOGO (DiscountCodeBxgy, mask product, repeats per pair,
   combines with product discounts so the pillow BxGy still fires). The popup
   applies it to the cart and sends the shopper to /checkout?discount=MASKBOGO.
   Mask quantity always moves in PAIRS so every paid mask has its free one.
   When MASKBOGO applies, Shopify prefers it over the 2/3 Pack Deal automatic
   discounts on the same lines (verified: 4 masks -> 2 paid at full unit price).
   If MASKBOGO is disabled or renamed in admin, step 3 would quote half price
   and checkout would charge pack-deal prices instead. Keep them in sync.

   Prices are read from the live product JSON, never hardcoded: the store sells
   in ~45 markets and each must show its own converted price. */
(function () {
  'use strict';

  var HANDLE = 'flyhugz-exclusive-bogo-deals';
  var MASK_HANDLE = 'flyhugz-premium-sleep-mask-2026';
  /* Israel (ILS): masks are "every 2 for ₪79.90" = pay one at ₪69.90, the second is 85.7% off (₪10) via
     MASKBOGOIL. Everywhere else the second mask is free via MASKBOGO. */
  var MASK_IL = !!(window.Shopify && Shopify.currency && Shopify.currency.active === 'ILS');
  var MASK_CODE = MASK_IL ? 'MASKBOGOIL' : 'MASKBOGO';
  function maskFreeUnit(unitCents) { return MASK_IL ? unitCents - Math.floor(unitCents * 0.857) : 0; }

  /* Swatches share one look: whole pillow, centred, on the #ebe6e2 studio
     ground of the Midnight Black shot (gray/pink/leopard were re-composited
     from their transparent originals on 2026-09-13 to match it). */
  var COLORS = [
    { name: 'Premium Gray',   sw: 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/fbp-swatch-gray.jpg?v=1789256783&width=160' },
    { name: 'Princess Pink',  sw: 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/fbp-swatch-pink.jpg?v=1789256783&width=160' },
    { name: 'NEW Leopard',    sw: 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/fbp-swatch-leopard.jpg?v=1789256783&width=160' },
    { name: 'Midnight Black', sw: 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/flyhugz-pillow-midnight-black-sku.jpg?v=1787245965&width=160' }
  ];
  var MASK_SW = [
    'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/Checkout_3.webp?v=1776117121&width=160',
    'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/7_b2eb4140-8245-46e0-8609-7819ee05c7b5.webp?v=1783010053&width=160',
    'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/53.webp?v=1775908192&width=160',
    'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/flyhugz-mask-midnight-black-swatch-v3.jpg?v=1787252183&width=160'
  ];
  var BEFORE = 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/ChatGPT_Image_Sep_12_2026_05_31_31_PM.webp?v=1789225548&width=420';
  var AFTER  = 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/ChatGPT_Image_Sep_12_2026_05_33_14_PM.webp?v=1789225542&width=420';

  /* tier n -> variant id per color index, straight from the live config */
  var TIERVARS = {
    2: [52379228078361, 52379228111129, 52379228143897, 53031399194905],
    4: [52394649485593, 52394650960153, 52394651451673, 53031399227673],
    6: [52394650173721, 52394651058457, 52394651877657, 53031399260441]
  };
  var MASKVARS = [52041567633689, 52041567666457, 52749152813337, 53029349556505];
  var MASK_MAX = 12;

  var TIERS = [
    { n: 2, payFor: 1, label: 'Buy 1 Get 1 FREE', sub: '💑 For you and a travel partner' },
    { n: 4, payFor: 2, label: 'Buy 2 Get 2 FREE', sub: '👨‍👩‍👧 Enjoy comfort with the family', flag: 'MOST POPULAR', xoff: 'EXTRA $10 OFF' },
    { n: 6, payFor: 3, label: 'Buy 3 Get 3 FREE', sub: '🎁 A perfect gift for loved ones', flag: 'BEST VALUE', xoff: 'EXTRA $20 OFF', flagAlt: 1 }
  ];

  var root = document.querySelector('.fbp');
  var modal = document.querySelector('[data-fbp-modal]');
  if (!root || !modal) return;

  var elBody = modal.querySelector('[data-fbp-body]');
  var elFoot = modal.querySelector('[data-fbp-foot]');
  var elStep = modal.querySelector('[data-fbp-steplabel]');
  var elRail = modal.querySelector('[data-fbp-rail]');

  var priceOf = {}, compareOf = {};
  var pricesReady = false;   /* step 1 must never print a 0.00 tier */
  /* maskQty defaults to one mask per pillow (always even: 2/4/6) and moves in
     pairs on step 3. null = "not chosen yet", so it re-seeds from the tier if
     they go back and change how many pillows they want. */
  var state = { step: 1, tier: 1, colors: [0,0,0,0,0,0], maskQty: null, busy: false };

  function money(cents) {
    try {
      if (window.Shopify && Shopify.currency && window.Intl) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: Shopify.currency.active
        }).format(cents / 100);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) {
    return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }

  function unitPrice(n, ci) { return priceOf[TIERVARS[n][ci]] || 0; }
  function tierNow(t, ci) { return unitPrice(t.n, ci) * t.payFor; }
  function tierWas(t, ci) { return unitPrice(t.n, ci) * t.n; }

  function maskQtyNow() {
    var n = TIERS[state.tier].n;
    return state.maskQty == null ? n : state.maskQty;
  }
  /* Mask k takes the color of pillow k (wrapping if they add more masks than
     pillows), so every mask matches a pillow in the order. */
  function maskColorAt(k) {
    var n = TIERS[state.tier].n;
    var ci = state.colors[k % n];
    return ci == null ? 0 : ci;
  }

  function loadOne(handle) {
    return fetch('/products/' + handle + '.js' + (window.Shopify&&Shopify.country?'?country='+Shopify.country+'&_c='+(Shopify.currency&&Shopify.currency.active):''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        (p.variants || []).forEach(function (v) {
          priceOf[v.id] = v.price;
          if (v.compare_at_price) compareOf[v.id] = v.compare_at_price;
        });
      });
  }
  function loadPrices() {
    return Promise.all([loadOne(HANDLE), loadOne(MASK_HANDLE)])
      .then(function () { pricesReady = true; });
  }

  /* ---------- steps ---------- */
  function rail() {
    var h = '';
    for (var i = 1; i <= 3; i++) h += '<span class="fbp__dot' + (i <= state.step ? ' on' : '') + '"></span>';
    elRail.innerHTML = h;
    elStep.textContent = 'Step ' + state.step + ' of 3';
  }

  function stepQuantity() {
    var ci = state.colors[0] || 0;
    var h = '<h2 class="fbp__h2">How many pillows?</h2>' +
            '<p class="fbp__lead">Every pillow you pay for comes with a second one free.</p>' +
            '<div class="fbp__tiers">';
    TIERS.forEach(function (t, i) {
      var now = tierNow(t, ci), was = tierWas(t, ci);
      h += '<div class="fbp__tierwrap">' +
           (t.flag ? '<span class="fbp__flag' + (t.flagAlt ? ' alt' : '') + '">' + esc(t.flag) +
                     (t.xoff ? '<i>|</i><b>' + esc(t.xoff) + '</b>' : '') + '</span>' : '') +
           '<button type="button" class="fbp__tier' + (i === state.tier ? ' on' : '') + '" data-fbp-tier="' + i + '">' +
             '<span class="fbp__radio"></span>' +
             '<span class="fbp__tinfo"><span class="fbp__tname">' + esc(t.label) + '</span>' +
             '<span class="fbp__tsub">' + esc(t.sub) + '</span></span>' +
             (now
             ? '<span class="fbp__tpr">' + (was > now ? '<s>' + money(was) + '</s>' : '') +
               '<b>' + money(now) + '</b><em>' + money(Math.round(now / t.n)) + ' each</em></span>'
             : '<span class="fbp__tpr fbp__skel" aria-hidden="true"></span>') +
           '</button></div>';
    });
    h += '</div>';
    elBody.innerHTML = h;
    elFoot.innerHTML = '<button type="button" class="fbp__next" data-fbp-go="2">Continue → pick your colors</button>' +
                       '<p class="fbp__fine">🛡 60-day guarantee · 🚚 Free shipping</p>';
  }

  function stepColors() {
    var t = TIERS[state.tier];
    var h = '<h2 class="fbp__h2">Pick your colors</h2>' +
            '<p class="fbp__lead">' + esc(t.label) + ' · ' + t.n + ' pillows · mix them however you like.</p>' +
            '<div class="fbp__colors' + (t.n > 4 ? ' fbp__colors--dense' : '') + '">';
    for (var u = 0; u < t.n; u++) {
      var sel = state.colors[u] == null ? 0 : state.colors[u];
      var free = u >= t.payFor;
      h += '<div class="fbp__crow"><span class="fbp__clab">Pillow ' + (u + 1) +
           (free ? '<br><i>FREE \uD83C\uDF81</i>' : '') + '</span>';
      COLORS.forEach(function (c, ci) {
        h += '<button type="button" class="fbp__sw' + (ci === sel ? ' on' : '') +
             '" data-fbp-unit="' + u + '" data-fbp-ci="' + ci + '" title="' + esc(c.name) +
             '" aria-label="' + esc(c.name) + '" style="background-image:url(\'' + c.sw + '\')"></button>';
      });
      h += '<span class="fbp__cname">' + esc(COLORS[sel].name) + '</span></div>';
    }
    h += '</div>';
    elBody.innerHTML = h;

    var now = tierNow(t, state.colors[0] || 0), was = tierWas(t, state.colors[0] || 0);
    elFoot.innerHTML =
      (now ? '<div class="fbp__total"><span>Your total</span><span>' +
        (was > now ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(now) + '</b>' +
        '<em>' + money(Math.round(now / t.n)) + ' each</em></span></div>' : '') +
      '<button type="button" class="fbp__next" data-fbp-go="3">Continue</button>' +
      '<button type="button" class="fbp__back" data-fbp-go="1">← Back to deals</button>';
  }

  function stepMask() {
    var t = TIERS[state.tier];
    var qty = maskQtyNow();
    var paid = qty / 2, free = qty / 2;
    var vid0 = MASKVARS[maskColorAt(0)];
    var unit = priceOf[vid0] || 0, cmpUnit = compareOf[vid0] || 0;
    var line = unit * paid + maskFreeUnit(unit) * free;   /* exactly what checkout charges */
    var each = Math.round(line / qty);          /* effective price per mask */

    /* which colors, and how many of each, in pillow order */
    var counts = {}, order = [];
    for (var k = 0; k < qty; k++) {
      var c = maskColorAt(k);
      if (!(c in counts)) { counts[c] = 0; order.push(c); }
      counts[c]++;
    }

    var h = '<div class="fbp__proof">🔥 87% of customers took this deal</div>' +
            '<h2 class="fbp__h2">Add matching sleep masks?</h2>' +
            '<p class="fbp__lead"><b class="fbp__bogo">' + (MASK_IL && unit ? 'Buy ' + paid + ' Get ' + free + ' for ' + money(line) : 'Buy ' + paid + ' Get ' + free + ' FREE') + '</b> \u00b7 matched to your pillow colors</p>' +
            '<div class="fbp__ba">' +
              '<figure><img src="' + BEFORE + '" alt="Traveler squinting under the cabin lights without a sleep mask"><figcaption>Without</figcaption></figure>' +
              '<figure><img src="' + AFTER + '" alt="Traveler asleep wearing the FlyHugz sleep mask"><figcaption class="on">With</figcaption></figure>' +
            '</div>' +
            '<div class="fbp__maskcard"><span class="fbp__mbadge">' + (MASK_IL && unit ? 'BUY ' + paid + ' GET ' + free + ' FOR ' + money(line) : 'BUY ' + paid + ' GET ' + free + ' FREE') + ' \uD83C\uDF81</span>' +
              '<div class="fbp__mrow">' +
                '<span class="fbp__mthumb" style="background-image:url(' + MASK_SW[order[0]] + ')"></span>' +
                '<div class="fbp__minfo"><b>Premium Sleep Mask</b>' +
                  (unit
                    ? '<span class="fbp__mpr">' + (cmpUnit > each ? '<s>' + money(cmpUnit) + '</s>' : '') +
                        '<b>' + money(each) + '</b><i>each</i></span>'
                    : '<span class="fbp__skel" aria-hidden="true"></span>') +
                  '<span class="fbp__mmeta">\uD83C\uDF81 ' + (MASK_IL ? (qty + ' masks') : (free + ' FREE')) + (unit ? ' \u00b7 ' + money(line) : '') +
                    '<span class="fbp__mdots" title="Matched to your pillows">';
    order.forEach(function (ci) {
      for (var r = 0; r < counts[ci]; r++) {
        h += '<span class="fbp__mdot" style="background-image:url(' + MASK_SW[ci] + ')" title="' + esc(COLORS[ci].name) + '"></span>';
      }
    });
    h +=            '</span></span>' +
                '</div>' +
                '<span class="fbp__qstep">' +
                  '<button type="button" data-fbp-mq="-2" aria-label="Two fewer masks"' + (qty <= 2 ? ' disabled' : '') + '>\u2212</button>' +
                  '<b>' + qty + '</b>' +
                  '<button type="button" data-fbp-mq="2" aria-label="Two more masks"' + (qty >= MASK_MAX ? ' disabled' : '') + '>+</button>' +
                '</span>' +
              '</div>' +
            '</div>';
    elBody.innerHTML = h;

    var base = tierNow(t, state.colors[0] || 0);
    elFoot.innerHTML =
      (base && unit ? '<div class="fbp__total"><span>Subtotal</span><span><b>' + money(base + line) + '</b></span></div>' : '') +
      '<button type="button" class="fbp__next" data-fbp-buy="1">Yes, add ' + qty + ' masks &amp; checkout →</button>' +
      '<button type="button" class="fbp__back" data-fbp-buy="0">No thanks, checkout with ' + t.n + ' pillows</button>' +
      '<p class="fbp__err" hidden></p>';
  }

  function render() {
    rail();
    if (state.step === 1) stepQuantity();
    else if (state.step === 2) stepColors();
    else stepMask();
    elBody.scrollTop = 0;
  }

  /* ---------- cart payload ----------
     Byte-for-byte the same line properties the live fhm-bundle-m1 builder sends
     (captured from flyhugz-exclusive-bogo-deals on 2026-09-13), so the cart drawer
     renders these lines exactly like the real lander: product photo, "Pillow 1:
     Premium Gray" rows with colour swatches, "🎁 Gift" rows, struck compare total
     and per-unit price. Without _main/_recipe/_was/_cur the drawer shows blank
     image boxes and nameless rows. Money fields are in the ACTIVE currency's major
     units, read from the live product JSON (compare_at_price = the lander's retail). */
  var CDN1 = 'https://cdn.shopify.com/s/files/1/0818/3060/9177/files/';
  function cu(u) { return (u && u.indexOf(CDN1) === 0) ? '~' + u.slice(CDN1.length) : (u || ''); }
  var PILLOW_MAIN = '~flyhugz-travel-pillow-gray-main_new.webp?v=1783021732&width=700';
  var PILLOW_OPT_IMG = [
    '~travel_pillow_gray.webp?v=1776070810&width=120',
    '~travel_pillow_pink.webp?v=1776070832&width=120',
    '~49.webp?v=1776008328&width=120',
    '~flyhugz-pillow-midnight-black-sku.jpg?v=1787245965&width=120'
  ];
  var MASK_MAIN = '~flyhugz-sleep-mask-gray.webp?v=1783030584&width=120';
  var MASK_NAMES = ['Premium Gray', 'Princess Pink', 'Leopard', 'Midnight Black'];
  function curCode() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; }
  function major(c) { return Math.round(c) / 100; }

  function pillowItems(bid) {
    var t = TIERS[state.tier], n = t.n, byVar = {}, units = {};
    for (var u = 0; u < n; u++) {
      var ci = state.colors[u] == null ? 0 : state.colors[u];
      var vid = TIERVARS[n][ci];
      if (!vid) continue;
      byVar[vid] = (byVar[vid] || 0) + 1;
      (units[vid] = units[vid] || []).push({ c: ci });
    }
    var cur = curCode();
    var retail = major(compareOf[TIERVARS[n][0]] || (priceOf[TIERVARS[n][0]] || 0) * 2);
    var recipe = {
      t: 'a', main: PILLOW_MAIN, retail: retail, cur: cur,
      opts: COLORS.map(function (c, ci) {
        return { n: c.name, i: PILLOW_OPT_IMG[ci], v: TIERVARS[n][ci],
                 vAll: TIERS.map(function (tt) { return TIERVARS[tt.n][ci]; }) };
      }),
      parts: null, unitNoun: 'Pillow',
      tierN: TIERS.map(function (tt) { return tt.n; }),
      tierPayFor: TIERS.map(function (tt) { return tt.payFor; }),
      tierTot: TIERS.map(function (tt) { return major((priceOf[TIERVARS[tt.n][0]] || 0) * tt.payFor); }),
      maxTier: TIERS.length
    };
    var recipeJson = JSON.stringify(recipe);
    var bcode = (t.payFor != null && t.payFor < n) ? ('b' + t.payFor + 'g' + (n - t.payFor)) : '';
    return Object.keys(byVar).map(function (vid) {
      var p = { _main: PILLOW_MAIN, _units: JSON.stringify(units[vid]), _was: (byVar[vid] * retail).toFixed(2),
                _uq: String(byVar[vid]), _bid: bid, _t: 'a', _cur: cur, _recipe: recipeJson };
      if (bcode) p._bundle = bcode;
      return { id: Number(vid), quantity: byVar[vid], properties: p };
    });
  }
  function maskItems(bid) {
    var qty = maskQtyNow(), byVar = {}, units = {}, order = [];
    for (var k = 0; k < qty; k++) {
      var ci = maskColorAt(k);
      var vid = MASKVARS[ci] || MASKVARS[0];
      if (!(vid in byVar)) { byVar[vid] = 0; units[vid] = []; order.push(vid); }
      byVar[vid]++;
      units[vid].push({ c: ci });
    }
    var cur = curCode();
    var retail = major(compareOf[MASKVARS[0]] || (priceOf[MASKVARS[0]] || 0) * 2);
    var recipeJson = JSON.stringify({
      t: 'a', main: MASK_MAIN, retail: retail,
      opts: MASKVARS.map(function (v, ci) { return { n: MASK_NAMES[ci], i: cu(MASK_SW[ci]).replace('&width=160', '&width=120'), v: v }; })
    });
    return order.map(function (vid) {
      return { id: Number(vid), quantity: byVar[vid], properties: {
        _main: MASK_MAIN, _units: JSON.stringify(units[vid]), _was: (byVar[vid] * retail).toFixed(2),
        _uq: String(byVar[vid]), _bid: bid, _t: 'a', _cur: cur, _recipe: recipeJson } };
    });
  }

  /* Keep the storefront language at checkout: a bare /checkout opens in English even from /he. */
  function checkoutUrl(q) {
    var l = document.documentElement.lang || 'en', p = [];
    if (q) p.push(q);
    if (l.indexOf('en') !== 0) p.push('locale=' + encodeURIComponent(l));
    return '/checkout' + (p.length ? '?' + p.join('&') : '');
  }
  function buy(withMask, btn) {
    if (state.busy) return;
    state.busy = true;
    var err = elFoot.querySelector('.fbp__err');
    if (err) err.hidden = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.setAttribute('disabled', 'disabled');

    var bid = String(Date.now()) + '-' + Math.floor(Math.random() * 10000);   /* one group id for pillows + masks, like the lander */
    var items = pillowItems(bid);
    if (withMask) items = items.concat(maskItems(bid));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add to cart');
        if (!withMask) { window.location.href = checkoutUrl(''); return; }
        /* Apply the mask BOGO code to the cart too, then hand it to checkout in
           the URL as well: either path alone is enough, both is belt and braces. */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: MASK_CODE })
        }).catch(function () {}).then(function () {
          window.location.href = checkoutUrl('discount=' + encodeURIComponent(MASK_CODE));
        });
      })
      .catch(function (e) {
        /* never strand the shopper on a dead button */
        state.busy = false;
        btn.textContent = label;
        btn.removeAttribute('disabled');
        if (err) { err.textContent = (e && e.message) || 'Something went wrong. Please try again.'; err.hidden = false; }
      });
  }

  /* ---------- events (delegated; the sheet re-renders every step) ---------- */
  modal.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-fbp-tier]'))) {
      state.tier = Number(el.getAttribute('data-fbp-tier'));
      state.maskQty = null;               /* re-seed from the new tier */
      render(); return;
    }
    if ((el = t.closest('[data-fbp-sw], .fbp__sw'))) {
      var u = Number(el.getAttribute('data-fbp-unit')), ci = Number(el.getAttribute('data-fbp-ci'));
      if (!isNaN(u) && !isNaN(ci)) { state.colors[u] = ci; render(); return; }
    }
    if ((el = t.closest('[data-fbp-mq]'))) {
      var d = Number(el.getAttribute('data-fbp-mq'));
      var q = maskQtyNow() + d;
      state.maskQty = Math.max(2, Math.min(MASK_MAX, q));   /* pairs, 2..12; "none" is No thanks */
      render(); return;
    }
    if ((el = t.closest('[data-fbp-go]'))) {
      state.step = Number(el.getAttribute('data-fbp-go'));
      if (state.step === 3) state.maskQty = null;   /* masks always start = pillows */
      render(); return;
    }
    if ((el = t.closest('[data-fbp-cf]'))) {
      var addMasks = el.getAttribute('data-fbp-cf') === 'add';
      hideConfirm();
      var fb = elFoot.querySelector('[data-fbp-buy="' + (addMasks ? '1' : '0') + '"]');
      if (fb) buy(addMasks, fb);
      return;
    }
    if ((el = t.closest('[data-fbp-buy]'))) {
      /* "No thanks" on the masks gets one last check before checkout */
      if (el.getAttribute('data-fbp-buy') === '0' && state.step === 3 && !state.busy) { showConfirm(); return; }
      buy(el.getAttribute('data-fbp-buy') === '1', el); return;
    }
    if (t.closest('[data-fbp-close]') || t === modal) close();
  });

  /* ---------- "sleep with annoying lights?" confirm ----------
     Shown when a shopper declines the masks. The primary action keeps the
     masks; declining again goes straight to checkout with pillows only. */
  var confirmEl = null;
  function showConfirm() {
    var sheet = modal.querySelector('.fbp__sheet');
    if (!sheet) return;
    if (!confirmEl) {
      confirmEl = document.createElement('div');
      confirmEl.className = 'fbp__confirm';
      confirmEl.setAttribute('role', 'alertdialog');
      confirmEl.setAttribute('aria-modal', 'true');
      confirmEl.setAttribute('aria-labelledby', 'fbp-cf-title');
      sheet.appendChild(confirmEl);
    }
    var qty = maskQtyNow();
    confirmEl.innerHTML =
      '<div class="fbp__cfcard">' +
        '<img src="' + BEFORE + '" alt="Traveler squinting under the cabin lights" class="fbp__cfimg">' +
        '<h3 id="fbp-cf-title" class="fbp__cftitle">Do you really want to sleep with annoying lights?</h3>' +
        '<p class="fbp__cflead">Cabin lights and screens are what keep you awake. Your masks are <b>' + (MASK_IL ? 'every 2 for a special price' : 'Buy 1 Get 1 FREE') + '</b> right now.</p>' +
        '<button type="button" class="fbp__next" data-fbp-cf="add">No, add my ' + qty + ' masks \uD83C\uDF81</button>' +
        '<button type="button" class="fbp__back" data-fbp-cf="skip">Yes, continue without masks</button>' +
      '</div>';
    confirmEl.hidden = false;
    var p = confirmEl.querySelector('[data-fbp-cf="add"]');
    if (p) { try { p.focus({ preventScroll: true }); } catch (e) { p.focus(); } }
  }
  function hideConfirm() { if (confirmEl) confirmEl.hidden = true; }

  var prevOverflow = '';
  function open() {
    if (!modal.hidden) return;
    prevOverflow = document.documentElement.style.overflow;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    state.step = 1;
    state.maskQty = null;
    render();
    var x = modal.querySelector('[data-fbp-close]');
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
  }
  function close() {
    hideConfirm();
    modal.hidden = true;
    document.documentElement.style.overflow = prevOverflow;   /* never blanket-clear */
  }

  /* ---------- the only way in ----------
     The hero section renders its own add-to-cart bound to THIS page's product.
     On a separate lander product that variant is NOT one the BxGy discounts are
     scoped to, so it must never submit. Rather than race the hero's own click
     handler, we REPLACE the button with a clone: cloning drops every listener
     already bound to it, and type="button" removes the implicit form submit.
     The capture listener below stays as a fallback for any add-to-cart rendered
     later (theme editor re-render). */
  function bindHero() {
    var n = 0;
    [].forEach.call(document.querySelectorAll('[data-fhp-atc], .fhp-atc'), function (b) {
      if (!b.parentNode || b.getAttribute('data-fbp-bound') !== null) return;
      var c = b.cloneNode(true);
      if (c.tagName === 'BUTTON') c.type = 'button';
      c.setAttribute('data-fbp-bound', '');
      b.parentNode.replaceChild(c, b);
      c.addEventListener('click', function (e) { e.preventDefault(); open(); });
      n++;
    });
    [].forEach.call(document.querySelectorAll('[data-fhp-form], .fhp-form'), function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); open(); });
    });
    return n;
  }

  /* If the hero ever stops rendering an add-to-cart, the page would have no way
     to buy at all. Render our own CTA rather than leave a dead lander. */
  function ensureCta() {
    if (bindHero()) return;
    root.hidden = false;
    root.innerHTML = '<div class="fbp__card">' +
      '<button type="button" class="fbp__cta" data-fbp-open>' +
        '<span>👉 Claim my free pillow</span>' +
        '<small>60-day money back guarantee</small></button>' +
      '<p class="fbp__reassure">Free shipping · 60-day guarantee</p></div>';
    root.querySelector('[data-fbp-open]').addEventListener('click', open);
  }
  ensureCta();

  /* ---------- review below the payment icons ----------
     On this lander the Amanda D. mini review sits under the hero buy box:
     CTA -> note -> trust pills -> payment icons -> review. Done here, not in
     fh-product-hero.liquid, because that section is shared with the real BOGO
     lander. The hero's own script relocates .fhp-mini on every mobile/desktop
     breakpoint change, so we re-apply after it on the same event. */
  function placeReview() {
    /* note: drop the hard-coded curly quotes so it reads as a badge, not a quote */
    var note = document.querySelector('.fhp-atc-note');
    if (note && !note.hasAttribute('data-fbp-note')) {
      note.textContent = note.textContent.replace(/^[\s\u201c"]+|[\s\u201d"]+$/g, '');
      note.setAttribute('data-fbp-note', '');
    }
    /* trust pills + payment icons become one card: the payment strip moves
       inside the trust row (the hero's mobile script anchors on .fhp-trustrow,
       so it keeps working) */
    var trust = document.querySelector('.fhp-trustrow');
    var pay = document.querySelector('.fhp-pay');
    if (trust && pay && pay.parentNode !== trust) trust.appendChild(pay);
    var mini = document.querySelector('.fhp-mini');
    var after = trust || pay;
    if (!mini || !after || !after.parentNode) return;
    if (after.nextSibling !== mini) after.parentNode.insertBefore(mini, after.nextSibling);
    mini.classList.add('fbp-mini-under-cta');
  }
  placeReview();
  try {
    var mqReview = window.matchMedia('(max-width:749px)');
    var onBp = function () { placeReview(); };
    if (mqReview.addEventListener) mqReview.addEventListener('change', onBp);
    else if (mqReview.addListener) mqReview.addListener(onBp);
  } catch (e) {}

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest('[data-fhp-atc], .fhp-atc, [data-fhp-form]');
    if (!hit || hit.getAttribute('data-fbp-bound') !== null) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-fhp-form], .fhp-form')) {
      e.preventDefault(); open();
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || modal.hidden) return;
    if (confirmEl && !confirmEl.hidden) hideConfirm(); else close();
  });

  /* Warm the before/after pair and swatches so later steps never open empty. */
  setTimeout(function () {
    try {
      [BEFORE, AFTER].concat(COLORS.map(function (c) { return c.sw; })).forEach(function (u) { new Image().src = u; });
    } catch (e) {}
  }, 2500);

  /* A shopper can reach step 1 before /products/*.js resolves — on a cold 4G
     load that is a real window. Re-render the moment prices land. */
  loadPrices().then(function () { if (!modal.hidden) render(); }).catch(function () {});
})();
